import React from "react";
import { decodeHashUrl } from "../shared-components/Utils/Functions";

import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withTranslation } from "../shared-components/i18n";

import { PropertyDetails } from "../shared-components/ViewFragments/PropertyDetails/web";
import { RTBhouse } from "../shared-components/Components/RTBhouse/web";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";

// ProjectSingle
const projectSingle = props => {
	return (
		<>
			<PropertyDetails id={props.__PROJECT__ID__} mode="project" />
			<RTBhouse page={"offer"} data={props.__PROJECT__ID__} />
		</>
	);
};

projectSingle.getInitialProps = async function({ apolloClient, req, res, query }) {
	let project = await decodeHashUrl(query.hashed);
	const __PROJECT__ID__ = project.id;
	return {
		__PROJECT__ID__,
		UrlToBack: query.location || -1,
		DummyContextInitialState: { count: 23 },
		ConfigContextInitialState: project?.configs,
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(projectSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);
